export default {"src":"/_next/static/media/ella.c1208863.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};